/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PhoneNumberRequest
 */
export interface PhoneNumberRequest {
    /**
     * The phone number provided by the user
     * @type {string}
     * @memberof PhoneNumberRequest
     */
    phoneNumber: string;
}

/**
 * Check if a given object implements the PhoneNumberRequest interface.
 */
export function instanceOfPhoneNumberRequest(value: object): value is PhoneNumberRequest {
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    return true;
}

export function PhoneNumberRequestFromJSON(json: any): PhoneNumberRequest {
    return PhoneNumberRequestFromJSONTyped(json, false);
}

export function PhoneNumberRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneNumberRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'phoneNumber': json['phoneNumber'],
    };
}

export function PhoneNumberRequestToJSON(value?: PhoneNumberRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'phoneNumber': value['phoneNumber'],
    };
}

